import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    
    path: ':locale/account',
    loadChildren: () =>
      import('./modules/ecommerce/account/account.module').then(
        (m) => m.AccountModule
      ),
  },
  {
    path: ':locale/cart',
    loadChildren: () =>
      import('./modules/ecommerce/cart/cart.module').then((m) => m.CartModule),
  },
  {
    path: 'order',
    loadChildren: () =>
      import('./modules/ecommerce/order/order.module').then(
        (m) => m.OrderModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledNonBlocking',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
